/**------------------------------------------------------
 * Interface Definitions
 */
export interface IAddonFacebookGreetings {
	logged_in_greeting  : string;						// NOTE: keep format, it is required by facebook!
	logged_out_greeting : string;
}

export interface IAddonFacebookCustomerChat {
	show(shouldShowDialog: boolean): void;				// Call this function to show the plugin on your page (You can use the shouldShowDialog parameter to decide if the dialog should also be shown)
	hide()		: void;									// Call this function to hide the entire plugin on your page
	showDialog(): void;									// Call this function to show the plugin dialog
	hideDialog(): void;									// Call this function to hide the plugin dialog
	update(greetings: IAddonFacebookGreetings): void;	// This function allows you to update the greeting text and/or the ref params
}

export interface IAddonFacebookCustomerChatEvent {
	subscribe(eventName: string, callback: () => void): void;
}

export interface IAddonFacebookXmlSocialPlugin {
	parse : () => void;
}


/**------------------------------------------------------
 * Abstract Class to Implement
 */
export abstract class AbstractAddonFacebookChat {
	abstract show(): void;
	abstract hide(): void;
	abstract onShow(callback: () => void): void;
	abstract onHide(callback: () => void): void;
	abstract onLoad(callback: () => void): void;
}
